// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1EVLf","title":"InfoRow_title__35Qy9"};